import * as React from 'react';
import PopupContent from './PopupContent';

function WarningPopupContent(props) {
    return (
        <PopupContent
            problems={props.problems}
            intro=" We have identified some issues that you may want to revisit
                before you launch."
            description="These suggestions will not prevent the project from launching, but we do
                encourage you to revise the project, just in case there are any
                mistakes."
            close={props.close}
            hideFooter={props.hideFooter}
        />
    );
}

export default WarningPopupContent;
